import { CurrencyHelper } from '@marketplace/myconverter';

import { CURRENCY_RATIO_DEFAULT } from '..';

const convertBigIntToNumber = (obj: Record<string, unknown>) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  const newObj: Record<string, unknown> = {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      newObj[key] =
        typeof value === 'bigint'
          ? Number(value)
          : convertBigIntToNumber(value as Record<string, unknown>);
    }
  }

  return newObj;
};

export const convertRequestToQueryKey = (
  method: string,
  request: Record<string, unknown>,
) => {
  return `${method}-${JSON.stringify(convertBigIntToNumber(request))}`;
};
